<script lang="ts" setup>
import AppButton from "~/components/ui/buttons/AppButton.vue";
import ArrowIcon from "~/assets/icons/arrows/16/arrow-left-black.svg?component"

withDefaults(defineProps<{
  txt?: string
}>(), {
  txt: 'Назад'
})

const router = useRouter()

const goToPreviousPage = () => router.go(-1)
</script>

<template>
<div class="back-link container">
  <AppButton
    :text="txt"
    :icon="ArrowIcon"
    type="ghost"
    size="s"
    :font-weight="500"
    @click="goToPreviousPage"
  />
</div>
</template>
